var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ac-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16.6 15.3999L12 10.7999L7.4 15.3999L6 13.9999L12 7.99991L18 13.9999L16.6 15.3999Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }